import React, { useRef } from 'react';
import { Link } from "react-router-dom";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import './homepage.css';
import { motion, useScroll, useTransform, useSpring } from "framer-motion";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AboutUsSection from './AboutUsSection';
import Partners from './Partners';
import FullImageSection from './FullImageSection';
import CTASection from './CTASection';
import BlogSection from './BlogSection';
import Footer from "./footer";
import Slideshow from './Slideshow';
import IconsRow from "./IconsRow";
import FooterCertificate from './enamad';

const images = [

"/images/sample2.png",
"/images/sample.png"
]



const AnimatedProductCard = ({ product }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 90%", "start 10%"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [50, 0]);
  const opacity = useTransform(scrollYProgress, [0, 1], [0, 1]);
  const smoothY = useSpring(y, { stiffness: 100, damping: 20 });
  const smoothOpacity = useSpring(opacity, { stiffness: 100, damping: 20 });

  return (
    <motion.div
      ref={ref}
      className="product-card"
      style={{ y: smoothY, opacity: smoothOpacity }}
    >
      <img src={product.image} alt={product.name} />
      <h3>{product.name}</h3>
    </motion.div>
  );
};




const HomePage = () => {
  const featuredProducts = [
    { id: 1, name: '‌ظروف فیروزه‌کوبی', price: '2,800 تومان', image: './images/firooze.png', path: '/products/turquoise-copper-dishes' },
    { id: 2, name: 'ظروف قلم‌زنی', price: '1,200 تومان', image: './images/ghalam.png', path: '/products/ghalamzani-dishes-art' },
    { id: 3, name: 'فرش دست‌بافت', price: '700 تومان', image: './images/carpet.png', path: '/products/carpet' },
  ];

  const iconItems = [
    { src: "/images/icons/carpet.png", label: "فرش" },
    { src: "/images/icons/turqoise.png", label: "فیروزه‌کوبی" },
    { src: "/images/icons/ghalam.png", label: "قلم‌زنی" },
    { src: "/images/icons/needlework.png", label: "سوزن‌دوزی" },
    { src: "/images/icons/clothing.png", label: "لباس محلی" },
    { src: "/images/icons/bag.png", label: "کیف و کوله" },
    { src: "/images/icons/accessorie.png", label: "اکسسوری" },
    { src: "/images/icons/curtain.png", label: "پرده" },
    { src: "/images/icons/rugonpot.png", label: "تکنیک گلیم روی سفال" },
    { src: "/images/icons/candle.png", label: "انواع شمع" },
  ];
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = () => {
    if (query.trim()) {
      navigate(`/search?q=${encodeURIComponent(query)}`);
    }
  };

  return (
    <div style={{ cursor: "url('/images/shell.png'), auto" }}>
      {/* Hero Section */}

      <section className="hero" data-aos="fade-up" data-aos-delay="100">
        <h1>گوهر صدف دریا، زینت خانه‌ شما</h1>
        <p>صنایع دستی، برآمده از عشق و هنر</p>
        <Link to="/products" className="hero-button">
          مشاهدۀ محصولات
        </Link>
      </section>


      {/* Search Bar */}
      <motion.section
        className="search-bar-section"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, ease: "easeOut" }}
      >
        <input
          type="text"
          className="search-input"
          placeholder="جستجوی محصولات..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSearch()} // allow Enter key
        />
        <button className="search-button" onClick={handleSearch}>
          جستجو
        </button>
      </motion.section>


      

      <IconsRow />


      {/*  Call To Action */}
      <CTASection />


      {/* Featured Products */} 
      <section className="featured" data-aos="fade-up" data-aos-delay="100">
        <h2>محصولات پرفروش</h2>
        <div className="product-grid">
          {featuredProducts.map((product) => (
            <Link key={product.id} to={product.path} className="product-link">
              <AnimatedProductCard product={product} />
            </Link>
          ))}
        </div>
      </section>




      <AboutUsSection />



      {/* Slider Section */}
    <div>
      <Slideshow images={images} interval={3000} />
    </div>

<Partners />


    <FullImageSection 
      desktopImage="/images/gallery-desktop.jpg"
      mobileImage="/images/gallery-phone.jpg"
      altText="Promotional Banner"
    />

    <BlogSection limit={4} />


      {/* Footer */}
      <FooterCertificate />
      <Footer />
    </div>
  );
};

export default HomePage;